import { Injectable } from '@angular/core';
import { BaseIndexedDbService } from "@core/storage/indexedDb/_database.service";
import { STORAGE_KEYS } from "@core/storage/indexedDb/_database.constants";
import { Trip } from "@core/api";

@Injectable({
  providedIn: 'root',
})
export abstract class TripIndexedDbService extends BaseIndexedDbService<Trip> {
  override objectStoreName = STORAGE_KEYS.trip;
}
